import { Link } from "react-router-dom";
import { ShieldCheck, Truck, RotateCcw, Headphones } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16">
      <div className="bg-white border-y">
        <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            [Truck, "Envío rápido", "A todo el país"],
            [ShieldCheck, "Pago seguro", "Tarjeta con Stripe"],
            [RotateCcw, "30 días", "Devolución fácil"],
            [Headphones, "Soporte 24/7", "Estamos contigo"],
          ].map(([Icon, t, s], i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-drelo-primary/10 grid place-items-center shrink-0">
                <Icon className="w-5 h-5 text-drelo-primary" />
              </div>
              <div>
                <div className="font-bold text-sm">{t}</div>
                <div className="text-xs text-drelo-muted">{s}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-drelo-ink text-white">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-5 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-1.5 mb-3">
              <span className="bg-drelo-primary text-white w-8 h-8 rounded-lg grid place-items-center font-display font-black text-xl">D</span>
              <span className="font-display font-black text-2xl tracking-tighter">drelo</span>
            </div>
            <p className="text-sm text-white/60">Tu tienda wellness. Productos que te hacen sentir mejor, a precios que sorprenden.</p>
          </div>
          <div>
            <h4 className="font-bold mb-3 text-sm">Tienda</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/tienda" className="hover:text-drelo-primary">Todos los productos</Link></li>
              <li><Link to="/tienda?category=Salud y Belleza" className="hover:text-drelo-primary">Salud y Belleza</Link></li>
              <li><Link to="/tienda?category=Hogar y Jardín" className="hover:text-drelo-primary">Hogar y Jardín</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3 text-sm">Gana con Drelo</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/embajadores" className="hover:text-drelo-primary">Programa de Embajadores</Link></li>
              <li><Link to="/embajadores" className="hover:text-drelo-primary">Refiere y gana</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/legal/terminos" className="hover:text-drelo-primary">Términos de Servicio</Link></li>
              <li><Link to="/legal/privacidad" className="hover:text-drelo-primary">Privacidad</Link></li>
              <li><Link to="/legal/envios" className="hover:text-drelo-primary">Envíos</Link></li>
              <li><Link to="/legal/devoluciones" className="hover:text-drelo-primary">Devoluciones</Link></li>
              <li><Link to="/legal/dmca" className="hover:text-drelo-primary">Aviso DMCA</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3 text-sm">Pagos aceptados</h4>
            <div className="flex flex-wrap gap-2 text-xs">
              <span className="bg-white/10 px-2.5 py-1 rounded">💳 Tarjeta</span>
            </div>
            <h4 className="font-bold mb-2 mt-5 text-sm">Contacto</h4>
            <p className="text-xs text-white/60">soporte@drelo.shop</p>
          </div>
        </div>
        <div className="border-t border-white/10 py-4 text-center text-xs text-white/40 space-y-1">
          <p>© {new Date().getFullYear()} Drelo Wellness · Hecho para convertir</p>
          <p>Pryma Wellness Group Inc. · 16192 Coastal Highway, Lewes, DE 19958, USA</p>
        </div>
      </div>
    </footer>
  );
}
